/**
 * config.js — Configuration centrale du frontend (P2-11).
 *
 * Source unique pour l'URL du serveur API. Remplace les ~63 déclarations
 * locales `const serverURL = process.env.REACT_APP_SERVER` dispersées dans
 * src/services, src/pages et src/components.
 *
 * Usage :
 *   import { SERVER_URL } from '../core/config';
 */

export const SERVER_URL = process.env.REACT_APP_SERVER;

const config = { SERVER_URL };

export default config;
